// extracted by mini-css-extract-plugin
export default {"page-container":"RootLayout_page-container__AZrTr","content-wrap":"RootLayout_content-wrap__9D-t7"};